import ButtonSwitch from './ButtonSwitch';
import './ButtonSwitch.scss';

export default ButtonSwitch;
